<div>
  @if (isConstraintsApplyScreen) {
    <div
      class="apply-constraint-toolbar mb-3 d-flex flex-column gap-3 align-items-start w-100"
      data-cy="apply_constraint_toolbar"
    >
      <mat-checkbox
        data-cy="reset_to_defaults_checkbox"
        [disabled]="isDisabled || !resetFlagControl"
        [checked]="resetToDefaultsChecked"
        (change)="onResetToDefaultsCheckboxChange($event.checked)"
      >
        Reset to defaults
      </mat-checkbox>
    </div>
  }
  <div cdkDropListGroup>
    <div
      class="d-flex gap-5"
      [ngClass]="{ 'read-only': isDragDropInteractionDisabled }"
    >
      <div class="container container-1">
        <div class="d-flex flex-column">
          <p class="fw-bold">{{ currentConfig?.sourceListDisplayText }}</p>
          <div
            class="drag-drop-list"
            [cdkDropListData]="sourceList"
            [cdkDropListDisabled]="isDragDropInteractionDisabled"
            (cdkDropListDropped)="drop($event)"
            cdkDropList
            cdkDropListSortingDisabled
          >
            @for (item of allValuesMap; track item) {
              <div
                class="drag-drop-item"
                [ngClass]="
                  item.disabled && !isDragDropInteractionDisabled
                    ? 'item-disable'
                    : ''
                "
                [cdkDragDisabled]="
                  isDragDropInteractionDisabled || item.disabled
                "
                cdkDrag
              >
                <div>{{ item.value }}</div>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="container container-2">
        <div class="d-flex flex-column">
          <p class="fw-bold">
            {{ currentConfig?.targetListDisplayText
            }}{{ currentConfig?.validators?.required ? " *" : "" }}
          </p>
          <div
            class="drag-drop-list"
            [cdkDropListData]="resultantList"
            [cdkDropListDisabled]="isDragDropInteractionDisabled"
            (cdkDropListDropped)="drop($event)"
            cdkDropList
          >
            @for (item of resultantList; track $index; let i = $index) {
              <div
                class="drag-drop-item d-flex"
                [cdkDragDisabled]="isDragDropInteractionDisabled"
                cdkDragLockAxis="y"
                cdkDrag
              >
                <div>{{ item }}</div>
                @if (!isDragDropInteractionDisabled) {
                  <div>
                    <i class="fa fa-trash-alt ms-2" (click)="remove(i)"></i>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        @if (resultantList.length === 0) {
          <mat-error>
            {{
              currentConfig?.errorMessages?.[
                keys(parentFormGroup?.get(currentConfig.property)?.errors)?.[0]
              ] || "Please select at least one constraint"
            }}
          </mat-error>
        }
      </div>
    </div>
  </div>
</div>
